import { render, staticRenderFns } from "./InputDataAsistenDokter.vue?vue&type=template&id=30049ba9&"
import script from "./InputDataAsistenDokter.vue?vue&type=script&lang=js&"
export * from "./InputDataAsistenDokter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports